module.exports = __webpack_public_path__ + "img/IMG_1149_L_Foamcore_MockedUp.0fa97769.jpg";